'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var errors = require('./errors.cjs');

const assertCanAdd = (candyMachine, index, amount) => {
  if (index + amount > candyMachine.itemsAvailable.toNumber()) {
    throw new errors.CandyMachineCannotAddAmountError(index, amount, candyMachine.itemsAvailable.toNumber());
  }
};
const assertAllItemConstraints = (candyMachine, items) => {
  if (candyMachine.itemSettings.type !== 'configLines') {
    return;
  }
  const {
    nameLength
  } = candyMachine.itemSettings;
  const {
    uriLength
  } = candyMachine.itemSettings;
  for (let i = 0; i < items.length; i++) {
    if (items[i].name.length > nameLength) {
      throw new errors.CandyMachineItemTextTooLongError(i, 'name', items[i].name, nameLength);
    }
    if (items[i].uri.length > uriLength) {
      throw new errors.CandyMachineItemTextTooLongError(i, 'uri', items[i].uri, uriLength);
    }
  }
};

exports.assertAllItemConstraints = assertAllItemConstraints;
exports.assertCanAdd = assertCanAdd;
//# sourceMappingURL=asserts.cjs.map
